import { render, staticRenderFns } from "./Leader_journey.vue?vue&type=template&id=2492dbca&scoped=true"
import script from "./Leader_journey.vue?vue&type=script&lang=js"
export * from "./Leader_journey.vue?vue&type=script&lang=js"
import style0 from "./Leader_journey.vue?vue&type=style&index=0&id=2492dbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2492dbca",
  null
  
)

export default component.exports